import { format } from 'date-fns';
import { TimeFormatOptions } from 'shared/types/date-format-options';

export const parseDateTime = (
  utcTimestamp: number,
  timeFormat: TimeFormatOptions,
) => {
  const date = new Date(utcTimestamp);
  const currentTimezoneDate = new Date(
    date.getTime() + date.getTimezoneOffset() * 60 * 1000,
  );
  return format(currentTimezoneDate, timeFormat);
};
